module.exports = __webpack_public_path__ + "mea-icon.ffa9859e4bf446e98f7afe5859e54ed5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/mea-icon.svg
// module id = 1145
// module chunks = 0